import React, { useRef, useEffect, useState } from "react";
import { MICROSITE_INSTRUCTIONS_SCREEN_VIEW, trackEvent } from "../../analytics";
import { Background, FullScreenLoader, GenericMessage, NavBar } from "../../Components/index";
import { ROUTE_LANDING_PAGE } from "../../Routes/RouteMapping";
import { STORAGE_WORK_PLATFORM_NAME } from "../../utils/constants";
import "./GenericPage.scss";
function GenericPage() {
  const onlyOnce = useRef(true);
  const [loader, SetLoader] = useState(false);

  useEffect(() => {
    const workPlatformName = sessionStorage.getItem(STORAGE_WORK_PLATFORM_NAME);
    if (workPlatformName) {
      if (onlyOnce.current) {
        trackEvent(MICROSITE_INSTRUCTIONS_SCREEN_VIEW, { work_platform_name: workPlatformName });
        onlyOnce.current = false;
      }
    }
  }, []);

  if (loader) return <FullScreenLoader showLoader={loader} />;

  return (
    <>
      <Background backButtonUrl={ROUTE_LANDING_PAGE}>
        <GenericMessage SetLoader={SetLoader} />
      </Background>
    </>
  );
}

export default GenericPage;
